import { useNavigate } from '@rocketlane/rocket-router';
import { Result } from 'antd';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Loading } from 'components/atoms/loading';
import { useCreateCustomerApiKey } from 'hooks/use-create-customer-api-key';
import { useQueryParamsFromWindow } from 'hooks/use-query-params';
import { API_KEY, logger } from 'services';
import { decodeJWT } from 'utils/http-utilts';

const redirect = (url: string) => {
  window.location.href = url;
};

export const CustomerPortalMagicLink = () => {
  const queryParams = useQueryParamsFromWindow();
  const router = useNavigate();

  const { mutateAsync } = useCreateCustomerApiKey();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const token = queryParams.get('token') as string;
    const apiKeyStr = localStorage.getItem(API_KEY);

    let route = '/';
    let inviteIfAbsent = false;

    try {
      const { payload } = decodeJWT(token);

      if (payload?.config?.hashParam) {
        const { hashParam } = payload.config;
        const decodedHashParam = decodeURIComponent(
          hashParam[0] === '#' ? hashParam.substring(1) : hashParam,
        );

        const params = new URLSearchParams(decodedHashParam);
        const kvParams = Object.fromEntries(params.entries());

        if (kvParams?.route) {
          route += kvParams.route;
        }
      }

      if (payload?.config?.projectId) {
        localStorage.setItem('ppi', payload.config.projectId);
      }

      inviteIfAbsent = payload?.config?.inviteIfAbsent ?? false;

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (err) {
      // pass
    }

    if (apiKeyStr != null && !inviteIfAbsent) {
      try {
        const apiKeyArr = JSON.parse(apiKeyStr);
        const apiKey = apiKeyArr?.at(1);

        if (apiKey) {
          router(route === '' ? '/' : route ?? '/');

          return;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (err) {
        // pass
      }
    } else if (apiKeyStr == null) {
      logger.debug("API key doesn't exist in local storage");
    }

    mutateAsync(
      { jwt: token },
      {
        onSuccess: (data) => {
          logger.debug('fetched api key for access token');
          localStorage.setItem(
            API_KEY,
            `["api_key", "${data?.apiKey}", ${data?.createdBy?.userId}, ${data?.apiKeyId}]`,
          );
          localStorage.setItem('customer_portal', 'true');
          setLoading(false);
          setError(false);
          // Reload to the JWT-decoded destination instead of the current URL
          // so the token query param is dropped — otherwise inviteIfAbsent=true
          // would re-trigger the invite on every reload (infinite loop).
          // Full page reload is retained so the auth flow boots cleanly.
          redirect(`${window.location.origin}${route}`);
        },
        onError: (_error) => {
          setLoading(false);
          setError(true);
        },
      },
    );
  }, [mutateAsync, queryParams, router]);

  if (loading) {
    return (
      <Result
        icon={<Loading />}
        title={<FormattedMessage id="logging_in" />}
        subTitle={<FormattedMessage id="logging_in.subtitle" />}
      />
    );
  }

  if (error) {
    return (
      <Result
        status="403"
        title={<FormattedMessage id="unauthorized" />}
        subTitle={<FormattedMessage id="unauthorized.subtitle" />}
      />
    );
  }

  return <></>;
};
